import { render, staticRenderFns } from "./EditLevelOneAcceptedType.vue?vue&type=template&id=6860634f&scoped=true&"
import script from "./EditLevelOneAcceptedType.vue?vue&type=script&lang=js&"
export * from "./EditLevelOneAcceptedType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6860634f",
  null
  
)

export default component.exports